import css from 'styled-jsx/css'
import { sizes } from '../../theme'
import common from '../../theme/common'


export default css`
    margin: 0 auto;

    .title {
        ${common.h5}
        display: block;
        margin-bottom: 2.4rem;
    }

    .text {
        ${common.h3};
        margin-bottom: 2.4rem;
    }

    figcaption {
        ${common.small}
        font-size: 1.4rem;
        text-transform: uppercase;
        font-family: 'Nexa Regular', sans-serif;
    }

    figcaption > * {
        display: block;
    }

    cite {
        font-style: normal;
    }

    @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
        .title {
            ${common.h5}
            margin-bottom: 1.2rem;
        }

        .text {
            ${common.t2}
            line-height: 1.3;
            margin-bottom: 1.2rem;
        }

        figcaption {
            font-size: 1.2rem;
        }
    }
`
